var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
import { Tag } from 'function-tree';
import Watch from './Watch';
import { isComputedValue } from './utils';
export var NestedComputedValue = function () {
  function NestedComputedValue(computed, nestedPath) {
    _classCallCheck(this, NestedComputedValue);
    this.computed = computed;
    this.propsTags = computed.propsTags;
    this.nestedPath = nestedPath;
  }
  _createClass(NestedComputedValue, [{
    key: 'getValue',
    value: function getValue(props) {
      return this.nestedPath.reduce(function (currentValue, key) {
        return currentValue && currentValue[key];
      }, this.computed.getValue(props));
    }
  }, {
    key: 'getDependencyMap',
    value: function getDependencyMap() {
      return this.computed.getDependencyMap();
    }
  }, {
    key: 'clone',
    value: function clone() {
      return this.computed.clone();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      return this.computed.destroy();
    }
  }]);
  return NestedComputedValue;
}();
export var Compute = function (_Watch) {
  _inherits(Compute, _Watch);
  function Compute(cb) {
    _classCallCheck(this, Compute);
    var _this = _possibleConstructorReturn(this, (Compute.__proto__ || Object.getPrototypeOf(Compute)).call(this, 'Compute'));
    _this.computedCallback = cb;
    _this.isDirty = true;
    _this.value = null;
    _this.props = null;
    _this.getters = null;
    _this.stateTags = [];
    _this.propsTags = [];
    _this.onUpdate = _this.onUpdate.bind(_this);
    _this.dynamicGetter = _this.dynamicGetter.bind(_this);
    _this.dynamicGetter.path = _this.dynamicPathGetter.bind(_this);
    return _this;
  }
  _createClass(Compute, [{
    key: 'createDependencyMap',
    value: function createDependencyMap() {
      return this.controller.createDependencyMap(this.stateTags, this.props, this.modulePath);
    }
  }, {
    key: 'getDependencyMap',
    value: function getDependencyMap() {
      return this.dependencyMap;
    }
  }, {
    key: 'onUpdate',
    value: function onUpdate() {
      this.isDirty = true;
    }
  }, {
    key: 'clone',
    value: function clone() {
      return new Compute(this.computedCallback).create(this.controller, this.modulePath, this.name + ' (clone)');
    }
  }, {
    key: 'compute',
    value: function compute() {
      this.executedCount++;
      return this.computedCallback(this.getDynamicGetter());
    }
  }, {
    key: 'getDynamicGetter',
    value: function getDynamicGetter() {
      this.stateTags = [];
      this.propsTags = [];
      return this.dynamicGetter;
    }
  }, {
    key: 'parseDependencies',
    value: function parseDependencies(tag) {
      var _this2 = this;
      if (!(tag instanceof Tag)) {
        throw new Error('Cerebral - Only tags are allowed in the dynamic "get" of Compute');
      }
      var allTags = tag.getTags();
      allTags.forEach(function (tag) {
        if (tag.type === 'props') {
          _this2.propsTags.push(tag);
        } else {
          _this2.stateTags.push(tag);
        }
      });
    }
  }, {
    key: 'dynamicGetter',
    value: function dynamicGetter(tag) {
      this.parseDependencies(tag);
      var value = tag.getValue(this.getters);
      if (isComputedValue(value)) {
        return value.getValue(this.props);
      }
      return value;
    }
  }, {
    key: 'dynamicPathGetter',
    value: function dynamicPathGetter(tag) {
      return tag.getPath(this.getters);
    }
  }, {
    key: 'hasChangedProps',
    value: function hasChangedProps(props) {
      var _this3 = this;
      var nextGetters = this.controller.createContext(props);
      return this.propsTags.reduce(function (hasChanged, tag) {
        if (hasChanged) {
          return true;
        }
        return tag.getValue(_this3.getters) !== tag.getValue(nextGetters);
      }, false);
    }
  }, {
    key: 'getValue',
    value: function getValue(props) {
      if (!this.controller) {
        throw new Error('This Cerebral Compute has not been added to a module');
      }
      if (!this.isDirty && this.propsTags.length && this.hasChangedProps(props)) {
        this.isDirty = true;
      }
      if (this.isDirty) {
        this.getters = this.controller.createContext(props);
        this.props = props;
        this.value = this.compute();
        var prevDependencyMap = this.dependencyMap;
        this.dependencyMap = this.createDependencyMap();
        this.controller.dependencyStore.updateEntity(this, prevDependencyMap, this.dependencyMap);
        if (this.controller.devtools) {
          this.controller.devtools.updateWatchMap(this, this.dependencyMap, prevDependencyMap);
          this.controller.devtools.updateComputedState(this.name, this.value);
        }
        this.isDirty = false;
      }
      return this.value;
    }
  }, {
    key: 'toString',
    value: function toString() {
      return this.getValue(this.props);
    }
  }]);
  return Compute;
}(Watch);
export default (function (cb) {
  return new Compute(cb);
});